import {provideZoneChangeDetection} from "@angular/core";

import {bootstrapApplication} from '@angular/platform-browser';
import {provideAnimations} from '@angular/platform-browser/animations';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import './app/leaflet-icon-fix';
import {DatePipe} from "@angular/common";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {activeLocationInterceptor} from "./app/core/interceptors/active-location.interceptor";

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideHttpClient(
      withInterceptors([activeLocationInterceptor])
    ),
    DatePipe,
    provideZoneChangeDetection(), ...(appConfig.providers || []),
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
